<template>
  <div class="add-user-page">
    <h2>Add New User</h2>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="user.email"
        label="Email"
        required
        :rules="[rules.required, rules.email]"
      />
      <v-text-field
        v-model="user.first_name"
        label="First Name"
        required
        :rules="[rules.required]"
      />
      <v-text-field
        v-model="user.last_name"
        label="Last Name"
        required
        :rules="[rules.required]"
      />
      <v-text-field v-model="user.title" label="Title" />
      <v-text-field v-model="user.account_ref" label="Account Ref" />
      <v-text-field
        v-model="user.employee_ref"
        label="Employee Ref"
        required
        :rules="[rules.required]"
      />
      <v-text-field v-model="user.department_name" label="Department Name" />
      <v-text-field v-model="user.department_ref" label="Department Ref" />
      <v-text-field v-model="user.group_name" label="Group Name" />
      <v-text-field v-model="user.group_ref" label="Group Ref" />
      <v-text-field v-model="user.crew_name" label="Crew Name" />
      <v-text-field v-model="user.crew_ref" label="Crew Ref" />
      <v-text-field
        v-model="user.supervisor_employee_ref"
        label="Supervisor Employee Ref"
      />
      <v-text-field v-model="user.phone_number" label="Phone Number" />
      <v-text-field v-model="user.level" label="Level" />
      <v-text-field v-model="user.role_name" label="Role Name" />
      <v-text-field v-model="user.role_ref" label="Role Ref" />
      <v-text-field v-model="user.rc_number" label="RC Number" />
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="!valid || loading"
        @click="submitUser"
        >Submit</v-btn
      >
      <v-btn @click="goBack">Cancel</v-btn>
    </v-form>
  </div>
</template>

<script>
import { CREATE_EMPLOYEE_MUTATION } from "@/graphql/accounts/mutations.js";

export default {
  name: "AddUserPage",
  data() {
    return {
      valid: false,
      loading: false,
      rules: {
        required: value => !!value || "Required.",
        email: value => /.+@.+\..+/.test(value) || "Invalid email."
      },
      user: {
        email: "",
        first_name: "",
        last_name: "",
        title: "",
        account_ref: "",
        employee_ref: "",
        department_name: "",
        department_ref: "",
        group_name: "",
        group_ref: "",
        crew_name: "",
        crew_ref: "",
        supervisor_employee_ref: "",
        phone_number: "",
        level: "",
        role_name: "",
        role_ref: "",
        rc_number: ""
      }
    };
  },
  methods: {
    async submitUser() {
      if (!this.$refs.form.validate()) return;

      const variables = {
        email: this.user.email,
        firstName: this.user.first_name,
        lastName: this.user.last_name,
        employeeRef: this.user.employee_ref,
        title: this.user.title || undefined,
        accountRef: this.user.account_ref || undefined,
        departmentName: this.user.department_name || undefined,
        departmentRef: this.user.department_ref || undefined,
        groupName: this.user.group_name || undefined,
        groupRef: this.user.group_ref || undefined,
        crewName: this.user.crew_name || undefined,
        crewRef: this.user.crew_ref || undefined,
        supervisorEmployeeRef: this.user.supervisor_employee_ref || undefined,
        phoneNumber: this.user.phone_number || undefined,
        roleName: this.user.role_name || undefined,
        rcNumber: this.user.rc_number || undefined,
        level: this.user.level || undefined,
        roleRef: this.user.role_ref || undefined
      };

      this.loading = true;
      try {
        const result = await this.$apollo.mutate({
          mutation: CREATE_EMPLOYEE_MUTATION,
          variables
        });
        const { successful, messages } = result.data.createEmployee;
        if (!successful) {
          this.$emit("alertError", messages.map(m => m.message).join("\n"));
          return;
        }
        this.$emit("alertSuccess", "User created successfully");
        this.goBack();
      } catch (error) {
        console.error(error);
        this.$emit("alertError", error.message);
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push("/users");
    }
  }
};
</script>

<style scoped>
.add-user-page {
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
}
</style>
